import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface ApplicationState {
  requireFullSSN: boolean;
  showModal: MODAL_ENUM;
  eligibilityVerified: boolean;
  loading: boolean;
  isSubmittingApp: boolean;
  subscribed: boolean;
  showLinkHHScreen: boolean;
  fullNumberEntered: boolean;
  showWelcomeBackCard: boolean;
  showPreSignupStatus: boolean;
  inStoreDevice?: boolean;
  proveSessionId: string;
  proveStatus: 'optedOut' | 'success' | 'noEmail' | 'fail';
}

export enum MODAL_ENUM {
  noModal,
  showDetailModal,
  showCreditAPRModal,
  showHowToUnfreezeModal,
  showLanguageDisclaimerModal,
  showLoginModal,
  showWelcomeBackInStoreModal,
}

const initialState: ApplicationState = {
  requireFullSSN: false,
  showModal: MODAL_ENUM.noModal,
  eligibilityVerified: false,
  loading: false,
  isSubmittingApp: false,
  subscribed: false,
  showLinkHHScreen: false,
  fullNumberEntered: false,
  showWelcomeBackCard: false,
  showPreSignupStatus: false,
  proveSessionId: '',
  proveStatus: 'optedOut',
};

const applicationScreenSlice = createSlice({
  name: 'applicationScreen',
  initialState,
  reducers: {
    requireFullSSN: (state, action: PayloadAction<boolean>) => {
      state.requireFullSSN = action.payload;
    },
    setShowModal: (state, action: PayloadAction<MODAL_ENUM>) => {
      state.showModal = action.payload;
    },
    setEligibilityVerified: (state, action: PayloadAction<boolean>) => {
      state.eligibilityVerified = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setIsSubmittingApp: (state, action: PayloadAction<boolean>) => {
      state.isSubmittingApp = action.payload;
    },
    setSubscribed: (state, action: PayloadAction<boolean>) => {
      state.subscribed = action.payload;
    },
    setShowLinkHHScreen: (state, action: PayloadAction<boolean>) => {
      state.showLinkHHScreen = action.payload;
    },
    setFullNumberEntered: (state, action: PayloadAction<boolean>) => {
      state.fullNumberEntered = action.payload;
    },
    setShowWelcomeBackCard: (state, action: PayloadAction<boolean>) => {
      state.showWelcomeBackCard = action.payload;
    },
    setShowPreSignupStatus: (state, action: PayloadAction<boolean>) => {
      state.showPreSignupStatus = action.payload;
    },
    setInStoreDevice: (state, action: PayloadAction<boolean>) => {
      state.inStoreDevice = action.payload;
    },
    setProveSessionId: (state, action: PayloadAction<string>) => {
      state.proveSessionId = action.payload;
    },
    setProveStatus: (
      state,
      action: PayloadAction<ApplicationState['proveStatus']>
    ) => {
      state.proveStatus = action.payload;
    },
  },
});

export const {
  requireFullSSN,
  setShowModal,
  setEligibilityVerified,
  setLoading,
  setIsSubmittingApp,
  setSubscribed,
  setShowLinkHHScreen,
  setFullNumberEntered,
  setShowWelcomeBackCard,
  setShowPreSignupStatus,
  setInStoreDevice,
  setProveSessionId,
  setProveStatus,
} = applicationScreenSlice.actions;
export default applicationScreenSlice.reducer;
